<template>


  <div v-if="data.post_condition">
    <h2 class="title others">Print Kondisi Mobil Selesai</h2>
    <div class="row mt-3 others mb-3">
      <div class="col-12 text-center">
        <button class="btn btn-info mr-3" style="width: 150px;" @click="printPage">Print</button>
        <!-- <button class="btn btn-primary" style="width: 75px;" @click="$emit('closeModal')">Kembali</button> -->
      </div>
    </div>
    <div  v-if="!data.post_condition.checklist['BARANG_CAR KEY'] && !data.post_condition.checklist['BARANG_CAR KEY'].check">
      <span style="color:red;font-size:14px">Versi Work Order Tersebut Tidak Dapat Dibuat Pengecekan Kondisi Internal Dikarenakan Work Order Versi Lama.</span>
    </div>
    <div style="border: 1px solid black" >

      <!-- PRINT Work Order START -->
      <div id="printMe" ref="printMe" v-if="data.post_condition">
        <print-header></print-header>  

        <h3 class="pl-3">Document Kondisi Mobil Selesai</h3>
        <!-- <hr> -->
        
        <div style="padding:20px 30px">
          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Nama</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ capitalize(data.customer.name) }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style=" font-size:12px; font-weight: 700;">C.S.O</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.CSO ? data.CSO : '-' }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Alamat</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.customer.address ? data.customer.address : '-' }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Nomor Polisi</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.customer_car.registration ? data.customer_car.registration : '-' }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Telepon / HP</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.customer.phone_number ? data.customer.phone_number : '-' }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Asuransi / Umum</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{data.customer_car.insurance.length > 0 ? data.customer_car.insurance[0].insuranceCompany.name : '-',}}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Merk / Tipe</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.customer_car.car.name ? data.customer_car.car.name : '-' }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Warna / Tahun</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.customer_car.car_color.name }}{{ data.customer_car.car_color.name && data.customer_car.year ? ' / ' : !data.customer_car.car_color.name && !data.customer_car.year ? '-' : '' }}{{ data.customer_car.year }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Kilometer</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.last_km != null ? numberWithCommas(data.last_km) : '-' }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Kondisi Accu</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.condition.accu.charging ? `C:${data.condition.accu.charging}%; ` : '' }}{{ data.condition.accu.health ? `H:${data.condition.accu.health}%` : '' }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">No. Work Order</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.form_code }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">BBM</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">{{ data.post_condition.fuel }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Perbaikan</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">-</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-3 contentTitle" style="margin-top:8px; font-size:12px; font-weight: 700;">Spare Part</div>
                <div class="col-1 mt-2 font-weight-bold">:</div>
                <div class="col-8 contentVariable" style="display: flex; flex-direction: column; justify-content: center; font-size: 14px;">-</div>
              </div>
            </div>
          </div>
        </div>


        <hr>
        <!-- {{data.post_condition.checklist['BARANG_CAR KEY']}} -->
        <div style="padding:0 30px" v-if="data.post_condition.checklist['BARANG_CAR KEY'] && data.post_condition.checklist['BARANG_CAR KEY'].check">
          <div style="margin-top:8px; font-size:12px; font-weight: 700;">Kondisi Internal / Perlengkapan :</div>
          <!-- {{data.post_condition.checklist}} -->
          <div class="row mt-3">
            <div class="col-3" style="font-size:10px;border: 1px solid black" v-for="check in Object.keys(data.post_condition.checklist).sort()">
              <!-- {{check}} -->
              <h6>{{translatePart(check.split('_')[0]) + ' - ' + prettifySentences(check.split('_')[1])}}</h6>
              <p>Status Barang : <b>{{data.post_condition.checklist[check].condition}}</b></p>
              <p>Deskripsi : <b>{{data.post_condition.checklist[check].desc}}</b></p>
              <p>Pengecekan Akhir : <b>{{data.post_condition.checklist[check].check}}</b></p>
              <!-- <span style="font-size:20px">{{ check.value.condition == 'Ada, Kondisi Oke' ? '✔' : check.value.condition == 'Tidak Ada' ? '—' : '✘' }}</span> {{ check.item }} -->
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          <h5>Versi Work Order Tersebut Tidak Dapat Dibuat Pengecekan Kondisi Internal Dikarenakan Work Order Versi Lama.</h5>
        </div>
      </div>
      <!-- PRINT WO END -->

	  <div v-else class="mt-4 mb-4">
		  <h4>Work Order Belum Selesai</h4>
	  </div>

    </div>
    
  </div>
  <div v-else class="text-center pt-5 pb-5">
    <h4 style="color:red">Tidak Bisa Print Kondisi Mobil Selesai Dikarenakan Work Order Belum Selesai.</h4>
  </div>

</template>

<script>
  import MultiSelect from 'vue-multiselect';
  import printHeader from '@/components/print/print_header.vue'
  import moment from 'moment'


  export default {
    data () {
      return {
        moment,
        placeholder : require('@/assets/img/placeholder.png'),
        internalConditions : [],
        figureGrouping : {
          front : ['front_bumper', 'front_left_light', 'front_right_light', 'front_windshield', 'grill', 'left_fog_light', 'right_fog_light'],
          rear : ['rear_bumper', 'rear_left_light', 'rear_right_light', 'rear_windshield'],
          left : ['front_left_door', 'front_left_fender', 'front_left_wheel', 'rear_left_door', 'rear_left_fender', 'rear_left_wheel'],
          right : ['front_right_door', 'front_right_fender', 'front_right_wheel', 'rear_right_door', 'rear_right_fender', 'rear_right_wheel'],
          atap : ['roof', 'sunroof']
        },
        damages : {
          front : [],
          rear : [],
          left : [],
          right : [],
          atap : []
        },
        dictionary : [
          {key:'front', value:'Depan'},
          {key:'rear', value: 'Belakang'},
          {key:'left', value: 'Kiri'},
          {key:'right', value: 'Kanan'},
          {key:'atap', value: 'Atap'}
        ]
      }
    },
    props : ['form_code', 'data', 'estimationData', 'complete'],
    components:{
      MultiSelect,
      printHeader,
    },
    async mounted () {
      this.internalConditions = await this.parseInternalCondition(this.data.condition.checklist);
      await this.parseExternalCondition(this.data.condition.figure);
      // this.printPage();
    },
    watch : {
      'selected.woStep'(){
        this.form.step_id = this.selected.woStep ? this.selected.woStep.id : '';
      },
      'selected.laborer'(){
        this.form.labourer_id = this.selected.laborer ? this.selected.laborer.id : '';
      }
    },
    methods : {
      translatePart (str) {
				let strSplit = str.toLowerCase()


					
        if(strSplit == 'front')
          strSplit = 'depan'
        else if (strSplit == 'atap')
          strSplit = 'atap'
        else if (strSplit == 'left')
          strSplit = 'kiri'
        else if (strSplit == 'right')
          strSplit = 'kanan'
        else if (strSplit == 'wheel')
          strSplit = 'roda'
        else if (strSplit == 'door')
          strSplit = 'pintu'
        else if (strSplit == 'light')
          strSplit = 'lampu'
        else if (strSplit == 'car')
          strSplit = 'mobil'
        else if (strSplit == 'window')
          strSplit = 'kaca'
        else if (strSplit == 'rear')
          strSplit = 'belakang'
        strSplit = strSplit.charAt(0).toUpperCase() + strSplit.slice(1)

				return strSplit
			},
      printPage(){
        let styles = null
        if(!this.complete)  {
          styles = {
            name: '_blank',
            specs: [
              'fullscreen=yes',
              'titlebar=yes',
              'scrollbars=yes'
            ],
            styles : [
              'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css',
              'https://unpkg.com/kidlat-css/css/kidlat.css',
              '/custom.css'
            ]
          }
        }

        this.$htmlToPaper('printMe')

        
      },
      parseInternalCondition(checklist){
        console.log(checklist)
        return Object.entries(checklist).map((x)=>{return {item:this.toCapitalizedWords(x[0].toLowerCase()), value:x[1]}})

        //Old Parser 2
        // return Object.keys(checklist).map((x)=>{return this.toCapitalizedWords(x.toLowerCase())})

        //Old Parser
        // var list = {}
        // for(var i in checklist) list[i.split("_")[0]] = 1;
        // return Object.keys(list).sort();
      },
      parseExternalCondition(figure){
        for(var i in figure){
          for(var j in figure[i]){
            if(figure[i][j] && figure[i][j].desc != ''){
              this.damages[i].push(`Kerusakan '${this.toCapitalizedWords(j)}'. Deskripsi : '${figure[i][j].desc}'`)
            }
          }
        }
      },
      noteTime(){
        this.$http.get(`/api/v1/workorder/${this.data.form_code}/detail/print`)
        .then((resp)=>{
          console.log('Print Lembar Kerja successfully noted');
        })
        .catch((err)=>{console.log(err)})
      },
    }
  }
</script>

<style scoped>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


.companyDetails{
  margin-bottom: 5px;
  font-size:.6rem;
}
/* .documentTitle{
  font-size: 40px;
  border: 1px solid black;
  border-radius: 10px;
  padding:20px 30px;
} */
.contentTitle{
  font-size:12px;
  font-weight: 700;
}
.contentVariable{
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
}

</style>